module.exports = __webpack_public_path__ + "media/img/features/payload-display-large-3333bd665e465e74a143ee58d768f17d.png";